
import { computed, defineComponent, toRefs } from "vue";

export default defineComponent({
	props: {
		ascending: {
			type: Boolean as () => boolean | null,
		},
	},
	setup(props, { emit }) {
		const { ascending } = toRefs(props);
		const topCaretVisible = computed(() => ascending.value !== false);
		const bottomCaretVisible = computed(() => ascending.value !== true);

		const toggle = () => {
			if (ascending.value === null) {
				emit("toggle", false);
			} else if (ascending.value === false) {
				emit("toggle", true);
			} else {
				emit("toggle", null);
			}
		};

		return { topCaretVisible, bottomCaretVisible, toggle };
	},
});
